export default __webpack_public_path__ + "static/media/floating_button.296d10ec.svg";